import React, { useState } from 'react'

import { Accordion } from '@/components/accordions/Accordion'
import { UnknownSectionCriteriaTable } from '../MeasureScoresTable/MeasureScoresTable'

import './scorecardForms.css'

function createCriteriaCell(criteria) {
  return (
    <td key={criteria.id} data-testid="criteria-name-cell">
      {criteria.name}
    </td>
  )
}

const getCriteriaItemsInSection = (criteria_not_in_playbook, section) => {
  const criteriaItemsInSection = []
  criteria_not_in_playbook.forEach((criteria) => {
    if (parseInt(criteria.scorecard_section_id, 10) === parseInt(section.id, 10)) {
      criteriaItemsInSection.push(criteria)
    }
  })
  return criteriaItemsInSection
}

const getCriteriaItemsInMeasure = (criteria_not_in_playbook, measure) => {
  const criteriaItemsInMeasure = []
  criteria_not_in_playbook.forEach((criteria) => {
    if (parseInt(criteria.scorecard_measure_id, 10) === parseInt(measure.id, 10)) {
      criteriaItemsInMeasure.push(criteria)
    }
  })

  return criteriaItemsInMeasure
}

export const CreateMeasureTable = ({ measure, missingCriteria }) => {
  return (
    <div data-testid="criteria-scores-summary__popup-card">
      <div className="update-playbook-form__measure-table-header">
        <h5>{measure.name}</h5>
      </div>
      <div className="update-playbook-form__measure-table-body">
        <UnknownSectionCriteriaTable
          missingCriteria={missingCriteria}
          cellFunction={createCriteriaCell}
        />
      </div>
    </div>
  )
}

export const CreateSectionTable = ({ scorecard }) => {
  const [expanded, setExpanded] = useState(false)
  const measureTables = scorecard.sections
    .filter((section) => {
      const criteriaItemsInSection = getCriteriaItemsInSection(
        scorecard.criteria_not_in_playbook,
        section
      )

      return criteriaItemsInSection.length
    })
    .map((section) => {
      const criteriaItemsInSection = getCriteriaItemsInSection(
        scorecard.criteria_not_in_playbook,
        section
      )
      return (
        <div
          className="measure-scores-table-container"
          data-testid="measure-scores-table-container"
        >
          <h4>{section.name}</h4>
          {section.measures
            .filter((measure) => {
              const criteriaItemsInMeasure = getCriteriaItemsInMeasure(
                criteriaItemsInSection,
                measure
              )
              return criteriaItemsInMeasure.length
            })
            .map((measure) => {
              const criteriaItemsInMeasure = getCriteriaItemsInMeasure(
                criteriaItemsInSection,
                measure
              )
              return (
                <CreateMeasureTable
                  measure={measure}
                  missingCriteria={criteriaItemsInMeasure}
                  key={measure.id}
                />
              )
            })}
        </div>
      )
    })

  if (!measureTables.length) return null

  return (
    <Accordion
      id={`scorecard-${scorecard.id}`}
      title={scorecard.name}
      expanded={expanded}
      handleToggle={() => setExpanded(!expanded)}
    >
      {measureTables}
    </Accordion>
  )
}

export const UpdatePlaybookForm = ({ scorecards }) => {
  const scorecardAccordions = scorecards.map((scorecard) => (
    <CreateSectionTable scorecard={scorecard} key={scorecard.id} />
  ))

  return (
    <div>
      <h3>Changes</h3>
      <p>
        Use the dropdown next to each scorecard to view the measures and criteria that will be
        affected once published.
      </p>

      {scorecardAccordions}
    </div>
  )
}
